import { createRolePermissionPickerOptionsFetcher } from "#src/contexts/AuthenticatedContext.helpers";
import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import { RoleCreateFormSchema } from "#src/routes/settings/roles-and-permissions/roles/create";
import {
  DropdownInput,
  Form,
  Panel,
  useForm,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { useCallback, useEffect, useMemo } from "react";
import { z } from "zod";
import styles from "./CreateRolePermissionsStep.module.scss";

const cx = classNames.bind(styles);

type RoleCreateFormValuesType = z.infer<typeof RoleCreateFormSchema>;

export const CreateRolePermissionsStep = () => {
  const { currentStep, getStep, updateStep } = useMultiStepFormContext();
  const stepDetails = getStep(3);
  const form = useForm<RoleCreateFormValuesType>({
    defaultValues: (stepDetails?.defaultValues ??
      {}) as RoleCreateFormValuesType,
  });

  const memoizedGetFormState = useCallback(
    () => ({
      isSubmitting: form.formState.isSubmitting,
      isValid: form.formState.isValid,
    }),
    [form.formState.isSubmitting, form.formState.isValid]
  );

  useEffect(() => {
    updateStep(3, {
      getValues: () => form.getValues(),
      getFormState: memoizedGetFormState,
    });
  }, [form]);

  const formKeys = RoleCreateFormSchema.keyof().Enum;

  const fetchPermissionOptions = useMemo(
    () =>
      createRolePermissionPickerOptionsFetcher(() =>
        form.getValues("selected_permissions")
      ),
    [form]
  );

  if (currentStep !== 3) {
    return null;
  }

  return (
    <Panel title={stepDetails?.label}>
      <Form {...form}>
        <div className={cx("detailsStepContainer")}>
          <DropdownInput
            label="Permissions"
            name={formKeys.selected_permissions}
            labelKey="label"
            valueKey="name"
            onFetchData={fetchPermissionOptions}
            isMulti
            isFluid
          />
        </div>
      </Form>
    </Panel>
  );
};
